import {AlertIcon, ArchiveIcon, LockIcon} from '@primer/octicons-react'

import {Resources} from '../../../strings'
import styles from './select-menu-error.module.css'

export function SelectMenuError({error}: {error: Error}) {
  const apiErrorCode = error.name
  let displayErrorMessage: string | undefined = undefined
  let icon

  switch (apiErrorCode) {
    case 'RepoArchived': {
      displayErrorMessage = Resources.repoArchivedErrorMessage
      icon = <ArchiveIcon size={26} />
      break
    }
    case 'Forbidden': {
      displayErrorMessage = Resources.forbiddenErrorMessage
      icon = <LockIcon size={26} />
      break
    }
    case 'IssueTypesDisabledForRepo':
    case 'IssueTypesDisabledForRepoOwner': {
      displayErrorMessage = error.message
      icon = <AlertIcon size={26} />
      break
    }
    default: {
      displayErrorMessage = Resources.genericErrorMessage
      icon = <AlertIcon size={26} />
      break
    }
  }

  return (
    <div className={styles.selectMenuErrorContainer}>
      <div className={styles.selectMenuErrorIcon}>{icon}</div>
      <p className={styles.selectMenuErrorText}>{displayErrorMessage}</p>
    </div>
  )
}
